/**
 * What the sign-in email looks like, so the "check your email" screen can tell
 * someone exactly what to look for.
 *
 * None of this is discoverable at runtime. GoTrue composes the From address from
 * the tenant's `SMTP_SENDER_NAME` and `SMTP_ADMIN_EMAIL`, which are container
 * env vars; `/auth/v1/settings` doesn't expose them, and `/config.json` only
 * carries the anon key. So it's declared here and has to be kept in step with
 * whatever the tenant is configured with.
 *
 * Override at build time rather than editing this file:
 *   VITE_MAIL_FROM_ADDRESS="dpltraining@dontpaniclabs.com"
 *   VITE_MAIL_FROM_NAME="DPL Training"
 *
 * Both halves of the real From header are shown, but they are not equal: the
 * ADDRESS is the thing someone can paste into a mailbox search, so it stays the
 * emphasized line. The display name is above it in muted text, because that is
 * what the inbox list actually shows and people scan for it first — but it is
 * the half mail clients rewrite, hide, or replace with a contact photo, so it
 * cannot be the only identifier offered.
 *
 * Keep both in step with the tenant's SMTP_ADMIN_EMAIL and SMTP_SENDER_NAME, or
 * the screen points people at a sender that never wrote to them.
 */
export const MAIL_FROM_ADDRESS =
  import.meta.env.VITE_MAIL_FROM_ADDRESS || 'dpltraining@dontpaniclabs.com'

/** The display name GoTrue sends as, from the tenant's `SMTP_SENDER_NAME`. */
export const MAIL_FROM_NAME =
  import.meta.env.VITE_MAIL_FROM_NAME || 'DPL Training'

/** GoTrue's default subject for the magic-link template. */
export const MAIL_SUBJECT = 'Your Magic Link'

/**
 * A placeholder code for the illustration. Six DIGITS, because that's what
 * GoTrue actually generates — an alphabetic example would have people looking
 * for the wrong shape of thing.
 */
export const MAIL_EXAMPLE_CODE = '123456'
